import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {AxisLabelsFormatterContextObject, Options} from "highcharts";

export class Norm extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'columnrange',
                inverted: true,
                marginLeft: 20,
                marginTop: 10,
                spacingBottom: 24,
                spacingTop: 11,
                width: 320
            },
            xAxis: {
                labels: {
                    // xAxis is labelled separately outside the chart
                    enabled: false
                }
            },
            yAxis: {
                min: 0.5,
                max: 9.5,
                gridLineWidth: 0,
                tickPositions: [0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 9.5],
                plotLines: [{
                    value: 0.5
                }, {
                    value: 1.5
                }, {
                    value: 2.5
                }, {
                    value: 3.5
                }, {
                    value: 4.5
                }, {
                    value: 5.5
                }, {
                    value: 6.5
                }, {
                    value: 7.5
                }, {
                    value: 8.5
                }, {
                    value: 9.5
                }],
                labels: {
                    style: {
                        fontSize: '6pt',
                        fontWeight: '400',
                        fontColor: 'black'
                    },
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        // Only return integer values as labels (no decimals)
                        const val = Number(this.value)
                        return val.valueOf() % 1 === 0 ? val.toString() : '';
                    }
                },
                title: {
                    useHTML: true,
                    text: null,
                    style: {
                        fontSize: '8.5pt',
                        fontWeight: '400',
                        color: 'black'
                    }
                }
            },
            plotOptions: {
                scatter: {
                    dataLabels: {
                        formatter: function (this: any) {
                            return this.point.label ? this.point.label : false;
                        },
                        enabled: true,
                        useHTML: true
                    }
                }
            },
            colors: [
                'black'
            ]
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Norm)
}